const TIME_UNITS = {
  s: 1000, // seconds
  m: 60 * 1000, // minutes
  h: 60 * 60 * 1000, // hours
  d: 24 * 60 * 60 * 1000, // days
  w: 7 * 24 * 60 * 60 * 1000, // weeks
} as const;

type TimeUnit = keyof typeof TIME_UNITS;

export const convertTimeToMilliseconds = (timeString: string): number => {
  if (!timeString || typeof timeString !== 'string') {
    return 3600000; // Default to 1 hour
  }

  const match = timeString.match(/^(\d+)([smhdw])$/);

  if (!match) {
    return 3600000; // Default to 1 hour
  }

  const [, valueStr, unit] = match;
  const value = parseInt(valueStr, 10);

  if (isNaN(value) || value <= 0) {
    return 3600000; // Default to 1 hour
  }

  const multiplier = TIME_UNITS[unit as TimeUnit];
  return value * multiplier;
};
